import { buildFallbackHeader } from "./buildFallbackHeader";
import { buildLogoHeader } from "./buildLogoHeader";
import {
  MONCO_BACKGROUND_PADDING_RATIO,
  MONCO_FALLBACK_FONT_SIZE_RATIO,
  MONCO_FALLBACK_TEXT_COLOR,
  MONCO_LOGO_MARGIN,
  MONCO_LOGO_WIDTH_RATIO,
  MONCO_URL,
  MONCO_URL_FONT_SIZE_RATIO,
} from "./constants";
import { tryLoadLogo } from "./tryLoadLogo";
import type { BuildMoncoBrandBlock } from "./types";

export const buildMoncoBrandBlock: BuildMoncoBrandBlock = async ({
  doc,
  pdfPageWidth,
  pdfPageHeight,
}) => {
  const longerPageSide = Math.max(pdfPageWidth, pdfPageHeight);
  const urlFontSize = longerPageSide * MONCO_URL_FONT_SIZE_RATIO;
  const urlGap = urlFontSize * 0.3;
  const backgroundPadding = longerPageSide * MONCO_BACKGROUND_PADDING_RATIO;
  const logoWidth = longerPageSide * MONCO_LOGO_WIDTH_RATIO;
  const fallbackFontSize = longerPageSide * MONCO_FALLBACK_FONT_SIZE_RATIO;

  // Set the URL font before measuring so getTextWidth uses the same metrics
  // we'll render with later.
  doc.setFont("helvetica", "normal");
  doc.setFontSize(urlFontSize);
  const urlTextWidth = doc.getTextWidth(MONCO_URL);

  const logoImage = await tryLoadLogo();
  const header = logoImage
    ? buildLogoHeader(doc, logoImage, logoWidth)
    : buildFallbackHeader(doc, fallbackFontSize);

  const contentWidth = Math.max(header.width, urlTextWidth);
  const contentHeight = header.height + urlGap + urlFontSize;
  const urlBaselineY = MONCO_LOGO_MARGIN + header.height + urlGap + urlFontSize;

  const draw = () => {
    doc.setFillColor(255, 255, 255);
    doc.rect(
      MONCO_LOGO_MARGIN - backgroundPadding,
      MONCO_LOGO_MARGIN - backgroundPadding,
      contentWidth + backgroundPadding * 2,
      contentHeight + backgroundPadding * 2,
      "F",
    );

    header.draw(MONCO_LOGO_MARGIN, MONCO_LOGO_MARGIN);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(urlFontSize);
    doc.setTextColor(...MONCO_FALLBACK_TEXT_COLOR);
    doc.textWithLink(MONCO_URL, MONCO_LOGO_MARGIN, urlBaselineY, {
      url: MONCO_URL,
    });
  };

  return {
    bottom: MONCO_LOGO_MARGIN + contentHeight + backgroundPadding,
    draw,
  };
};
